/**
 * EU legal guarantee notice dialog (snippets/eu-legal-guarantee.liquid).
 *
 * Loaded once from layout/theme.liquid and driven by event delegation, so it
 * also works for the copies of the product blocks that Impulse's quick shop
 * fetches and injects with innerHTML (an inline <script> there never runs).
 *
 * The dialog is a native <dialog> opened with showModal(): the browser moves
 * focus in (to the [autofocus] close button, so the notice shows from the
 * top), keeps it there, makes the page inert and closes on Esc. On top of
 * that this script:
 * - re-points aria-labelledby / aria-describedby at the current ids, because
 *   quick shop appends "-modal" to every id inside the blocks it copies;
 * - closes on a click on the backdrop;
 * - keeps the Esc that closed the notice from also closing the quick shop
 *   modal behind it. Impulse's modals close on window `keyup` Esc, which
 *   arrives after the dialog has already closed on `keydown`, so that one
 *   keyup is stopped in the capture phase at window, before any of them;
 * - locks page scroll while open and puts focus back on the trigger.
 */
(function () {
  if (window.euLegalGuaranteeInit) return;
  window.euLegalGuaranteeInit = true;

  var LOCK_CLASS = 'eu-lg-scroll-lock';
  var swallowEscapeUp = false;
  var swallowTimer;

  function wireAria(dialog) {
    var heading = dialog.querySelector('[data-eu-lg-heading]');
    var text = dialog.querySelector('[data-eu-lg-text]');
    var image = dialog.querySelector('[data-eu-lg-image]');
    if (heading && heading.id) dialog.setAttribute('aria-labelledby', heading.id);
    if (image && text && text.id) image.setAttribute('aria-describedby', text.id);
  }

  function open(trigger) {
    var root = trigger.closest('[data-eu-lg]');
    var dialog = root && root.querySelector('[data-eu-lg-dialog]');
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;

    wireAria(dialog);
    dialog.showModal();
    document.documentElement.classList.add(LOCK_CLASS);

    dialog.addEventListener('close', function onClose() {
      dialog.removeEventListener('close', onClose);
      if (!document.querySelector('[data-eu-lg-dialog][open]')) {
        document.documentElement.classList.remove(LOCK_CLASS);
      }
      trigger.focus();
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-eu-lg-open]');
    if (trigger) {
      open(trigger);
      return;
    }

    var closeButton = event.target.closest('[data-eu-lg-close]');
    if (closeButton) {
      closeButton.closest('[data-eu-lg-dialog]').close();
      return;
    }

    // A click on the ::backdrop targets the <dialog> itself; clicks on the
    // notice land on .eu-lg__dialog-inner or its children.
    if (event.target.matches && event.target.matches('[data-eu-lg-dialog][open]')) {
      event.target.close();
    }
  });

  // Esc fires `cancel` on keydown, then the dialog closes.
  document.addEventListener(
    'cancel',
    function (event) {
      if (!event.target.matches || !event.target.matches('[data-eu-lg-dialog]')) return;
      swallowEscapeUp = true;
      clearTimeout(swallowTimer);
      swallowTimer = setTimeout(function () {
        swallowEscapeUp = false;
      }, 1000);
    },
    true
  );

  window.addEventListener(
    'keyup',
    function (event) {
      if (!swallowEscapeUp) return;
      if (event.key !== 'Escape' && event.keyCode !== 27) return;
      swallowEscapeUp = false;
      clearTimeout(swallowTimer);
      event.stopPropagation();
    },
    true
  );
})();
